import { types } from "../types/types";
// Libreria para el uso de alertas
import Swal from "sweetalert2";
import axios from "axios";

//Método para obtener la IP del usuario
export const getIP = async () => {
  try {
    const responseIP = await axios.get("https://geolocation-db.com/json/");
    return responseIP;
  } catch (error) {
    throw error;
  }
};

export const setError = (err) => ({
  type: types.uiSetError,
  payload: err,
});

export const setLoadingActionScreen = (loading) => ({
  type: types.uiLoadingActionScreen,
  payload: loading,
});

export const setMsgActionScreen = (loading) => ({
  type: types.uiSetMsgActionScreen,
  payload: loading,
});

export const removeError = () => ({
  type: types.uiRemoveError,
});

export const startLoading = () => ({
  type: types.uiStartLoading,
});

export const finishLoading = () => ({
  type: types.uiFinishLoading,
});

export const errorAlert = (msgError, footer, msgFooter, linkFooter) => {
  Swal.fire({
    icon: "error",
    title: "Oops...",
    text: msgError,
    showConfirmButton: footer ? false : true,
    showClass: {
      popup: "animate__animated animate__fadeInDown",
    },
    hideClass: {
      popup: "animate__animated animate__fadeOutDown",
    },
    footer: footer ? `
    <a href="${linkFooter}" rel="noreferrer" target="_blank" class="font-bold underline text-saluta-p focus:outline-none">
    ${msgFooter}
    </a>` : null
  });
};

export const warningAlert = (msgError) => {
  Swal.fire({
    icon: "warning",
    title: "Algo Salió Mal",
    // text: "Ha sucedido un error consultando el copago en Fonasa. Por favor comuniquese con atencion al cliente o intentelo nuevamente más tarde.",
    text: msgError,
    showClass: {
      popup: "animate__animated animate__fadeInDown",
    },
    hideClass: {
      popup: "animate__animated animate__fadeOutDown",
    },
  });
};

export const successAlert = (msgSuccess) => {
  Swal.fire({
    position: "center",
    icon: "success",
    title: msgSuccess,
    showConfirmButton: false,
    allowOutsideClick: false,
    timer: 2000,
    showClass: {
      popup: "animate__animated animate__fadeInUp",
    },
    hideClass: {
      popup: "animate__animated animate__fadeOutDown",
    },
  });
};

export const confirmAlert = () => {
  Swal.fire({
    title: "¿Importar y Crear Citas en Saluta?",
    //text: "Desea Importar el Archivo en Setmore",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si",
    cancelButtonText: "Cancelar",
  }).then((result) => {
    if (result.isConfirmed) {
      return true;
    } else {
      return false;
    }
  });
};

export const deleteSuccess = () => {
  Swal.fire(
    'Eliminado!',
    'El documento ha sido eliminado.',
    'success'
  )
}

export const confirmAction = (msg, methodToExecute) => {
  Swal.fire({
    title: msg,
    text: "Esto no puede ser revertido!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Si!',
    cancelButtonText: 'Cancelar',
  }).then((result) => {
    if (result.isConfirmed) {
      methodToExecute();
    }
  })
}

export const confirmActionDispatch = (msg) => {
  return new Promise((resolve, reject) => {
    Swal.fire({
      title: msg,
      text: "Esto no puede ser revertido!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si!',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        resolve(true);
      }
      reject(false);
    })
  });
}

export const confirmActionAndChangeState = (msg, methodToExecute, state, changeState) => {
  Swal.fire({
    title: msg,
    text: "Esto no puede ser revertido!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Si!',
    cancelButtonText: 'Cancelar',
  }).then((result) => {
    if (result.isConfirmed) {
      methodToExecute();
      changeState(!state);
    }
  })
}

export const returnErrorFormik = (touched, error) => {
  return touched && error ? (
    <div className="text-red-400">{error}</div>
  ) : null
}
